var _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _rect3, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _circle2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0011 74.1873C23.0011 45.8502 46.0741 23 74.407 23C102.74 23 125.813 45.8333 125.813 74.1873C125.813 86.2159 121.644 97.2774 114.664 106.012C105.032 118.108 90.3289 125.376 74.4059 125.376C58.483 125.376 43.7604 118.063 34.1406 106.012C27.1604 97.2785 23 86.2169 23 74.1873H23.0011Z",
    fill: "url(#paint0_linear_3927_16825)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.991 50.5393V102.172C122.991 105.527 120.273 108.245 116.917 108.245H31.0805C27.7336 108.245 25 105.527 25 102.172V50.5393C25 50.0948 25.3624 49.7323 25.807 49.7323H122.186C122.637 49.7323 122.993 50.0948 122.993 50.5393H122.991Z",
    fill: "#F9FAFD",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 97,
    width: 26,
    height: 6,
    rx: 2,
    fill: "#C3CEF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123 45.0796V50.5461C123 50.9906 122.637 51.3531 122.193 51.3531H25.807C25.3624 51.3531 25 50.9906 25 50.5461V45.0796C25 41.7241 27.7336 39 31.0805 39H116.917C120.273 39 122.998 41.7264 122.998 45.0796H123Z",
    fill: "url(#paint1_linear_3927_16825)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.08 45.1753C33.08 46.0119 32.4051 46.6867 31.5729 46.6867C30.7408 46.6867 30.0614 46.0119 30.0614 45.1753C30.0614 44.3387 30.7362 43.664 31.5729 43.664C32.4097 43.664 33.08 44.3387 33.08 45.1753Z",
    fill: "#5A7FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4789 45.1753C38.4789 46.0119 37.804 46.6867 36.9719 46.6867C36.1397 46.6867 35.4603 46.0119 35.4603 45.1753C35.4603 44.3387 36.1351 43.664 36.9719 43.664C37.8086 43.664 38.4789 44.3387 38.4789 45.1753Z",
    fill: "#5A7FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8799 45.1753C43.8799 46.0119 43.2052 46.6867 42.373 46.6867C41.5409 46.6867 40.8614 46.0119 40.8614 45.1753C40.8614 44.3387 41.5363 43.664 42.373 43.664C43.2098 43.664 43.8799 44.3387 43.8799 45.1753Z",
    fill: "#5A7FFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 58,
    width: 33,
    height: 6,
    rx: 2,
    fill: "#C3CEF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 68,
    width: 18,
    height: 6,
    rx: 2,
    fill: "#C3CEF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.34 77.0537C134.224 76.0286 134.093 74.4709 133.063 73.5906C132.034 72.7102 130.482 72.8275 129.598 73.8526C128.714 74.8777 128.82 76.4365 129.85 77.3179C130.879 78.1982 132.457 78.0788 133.341 77.0537H133.34Z",
    fill: "url(#paint2_linear_3927_16825)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.762 69.5801C134.325 68.927 134.241 67.9368 133.586 67.3756C132.93 66.8155 131.943 66.8905 131.381 67.5426C130.818 68.1957 130.885 69.187 131.541 69.7481C132.197 70.3082 133.201 70.2321 133.763 69.5801H133.762Z",
    fill: "url(#paint3_linear_3927_16825)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7623 26.5801C45.3248 25.927 45.241 24.9368 44.5861 24.3756C43.9303 23.8155 42.9432 23.8905 42.3807 24.5426C41.8182 25.1957 41.8851 26.187 42.541 26.7481C43.1969 27.3082 44.2009 27.2321 44.7634 26.5801H44.7623Z",
    fill: "url(#paint4_linear_3927_16825)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0008 122.205C40.3574 121.422 39.9976 120.494 39.2112 120.139C38.4247 119.784 37.4972 120.132 37.1406 120.916C36.784 121.699 37.1289 122.633 37.9153 122.988C38.7018 123.343 39.6442 122.989 40.0008 122.206V122.205Z",
    fill: "url(#paint5_linear_3927_16825)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7157 126.465C48.276 125.234 47.7104 123.777 46.4739 123.219C45.2375 122.661 43.7814 123.207 43.221 124.438C42.6606 125.669 43.2019 127.136 44.4383 127.693C45.6748 128.251 47.1553 127.695 47.7157 126.464V126.465Z",
    fill: "url(#paint6_linear_3927_16825)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3403 31.0537C41.2244 30.0286 41.0928 28.4709 40.0633 27.5906C39.0338 26.7102 37.4822 26.8275 36.5981 27.8526C35.714 28.8777 35.8201 30.4365 36.8496 31.3179C37.8791 32.1982 39.4573 32.0788 40.3413 31.0537H40.3403Z",
    fill: "url(#paint7_linear_3927_16825)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.375 100.965L108.464 105.855L102.781 100.204C104.672 98.783 106.373 97.065 107.701 95.3142L113.376 100.965H113.375Z",
    fill: "url(#paint8_linear_3927_16825)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.056 100.135L128.048 111.08C130.651 113.672 130.651 117.877 128.048 120.469C125.444 123.062 121.222 123.062 118.618 120.469L107.627 109.525C106.843 108.744 106.843 107.478 107.627 106.698L114.217 100.135C115.001 99.3549 116.272 99.3549 117.056 100.135Z",
    fill: "url(#paint9_linear_3927_16825)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.3213,
    cy: 79.8213,
    r: 25.5213,
    fill: "url(#paint10_linear_3927_16825)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6679,
    cy: 80.1679,
    r: 18.5914,
    fill: "url(#paint11_linear_3927_16825)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5661 81.3676C84.5661 83.0185 83.2309 84.3534 81.5798 84.3534C79.9288 84.3534 78.5991 83.0185 78.5991 81.3676C78.5991 79.7168 79.9343 78.3873 81.5798 78.3873C83.2254 78.3873 84.5661 79.7223 84.5661 81.3676Z",
    fill: "#5A7FFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3822 81.9774C83.3822 82.6284 82.8547 83.1558 82.2036 83.1558C81.5525 83.1558 81.0278 82.6284 81.0278 81.9774C81.0278 81.3264 81.5553 80.8018 82.2036 80.8018C82.852 80.8018 83.3822 81.3292 83.3822 81.9774Z",
    fill: "#F9FAFD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0112 81.3676C99.0112 83.0184 97.676 84.3534 96.0249 84.3534C94.3738 84.3534 93.0442 83.0184 93.0442 81.3676C93.0442 79.7167 94.3793 78.3873 96.0249 78.3873C97.6705 78.3873 99.0112 79.7222 99.0112 81.3676Z",
    fill: "#5A7FFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8245 81.9774C97.8245 82.6284 97.297 83.1558 96.6459 83.1558C95.9948 83.1558 95.4701 82.6284 95.4701 81.9774C95.4701 81.3264 95.9976 80.8018 96.6459 80.8018C97.2943 80.8018 97.8245 81.3291 97.8245 81.9774Z",
    fill: "#F9FAFD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5275 76.4893L95.1237 74.8412C94.6155 74.6516 94.36 74.0858 94.5495 73.5804C94.7391 73.0722 95.305 72.814 95.8105 73.0063L100.214 74.6544C100.723 74.8439 100.978 75.4098 100.788 75.9179C100.596 76.4316 100.028 76.6815 99.5275 76.492V76.4893Z",
    fill: "#5A7FFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2475 75.9151C77.0579 75.407 77.3134 74.8439 77.8217 74.6516L82.2255 73.0035C82.7337 72.814 83.2969 73.0722 83.4892 73.5776C83.6787 74.0858 83.4233 74.6489 82.915 74.8384L78.5112 76.4865C78.0112 76.6733 77.4398 76.4261 77.2502 75.9124L77.2475 75.9151Z",
    fill: "#5A7FFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3738 87.504C91.3738 88.4626 90.3189 88.6604 89.0195 88.6604C87.72 88.6604 86.6651 88.4626 86.6651 87.504C86.6651 86.5454 87.72 85.5648 89.0195 85.5648C90.3189 85.5648 91.3738 86.5509 91.3738 87.504Z",
    fill: "#5A7FFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3927_16825",
    x1: 30.5,
    y1: 28.5,
    x2: 91,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3927_16825",
    x1: 74.0684,
    y1: 51.0544,
    x2: 73.8564,
    y2: 40.8601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6C6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3927_16825",
    x1: 131.464,
    y1: 73,
    x2: 131.464,
    y2: 77.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3927_16825",
    x1: 132.568,
    y1: 67,
    x2: 132.568,
    y2: 70.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3927_16825",
    x1: 43.568,
    y1: 24,
    x2: 43.568,
    y2: 27.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3927_16825",
    x1: 38.5694,
    y1: 120,
    x2: 38.5694,
    y2: 123.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3927_16825",
    x1: 45.4662,
    y1: 123,
    x2: 45.4662,
    y2: 127.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3927_16825",
    x1: 38.4638,
    y1: 27,
    x2: 38.4638,
    y2: 31.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3927_16825",
    x1: 102.781,
    y1: 100.585,
    x2: 113.375,
    y2: 100.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3927_16825",
    x1: 112.593,
    y1: 102.544,
    x2: 128.086,
    y2: 119.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95A8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3927_16825",
    x1: 69.73,
    y1: 60.1971,
    x2: 108.462,
    y2: 101.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6B9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3927_16825",
    x1: 75.7572,
    y1: 66.2244,
    x2: 100.029,
    y2: 95.1442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.91eceebf0588bc8c4630062eaa3aba9c.svg";
export { ForwardRef as ReactComponent };